import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@nxtpeople/nxt-styles';
import { ContractFeeFrequency } from './contract-fee-frequency.interface';

class ContractFeeFrequencyService {
   async getContractFeeFrequencies() {
      return await http
         .get<ApiResource<Array<ContractFeeFrequency>>>('/contract-fee-frequencies', cacheFirstConfig)
         .then((response) => response.data?.data ?? []);
   }
}

export default new ContractFeeFrequencyService();
